"use client";

import React from "react";
import { Truck, Sparkles, ShieldCheck, CreditCard, ArrowRight } from "lucide-react";
import { motion, useReducedMotion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const benefits = [{
  icon: Truck,
  title: "Envíos a todo México",
  description: "Recibe tu pedido en 2 días hábiles aproximadamente.",
  tag: "Cobertura nacional"
}, {
  icon: Sparkles,
  title: "Envío gratis en pedidos de $1,999 pesos para arriba",
  description: "El beneficio se calcula de manera automática al momento de pagar, sin necesidad de cupones.",
  tag: "Automático en caja"
}, {
  icon: ShieldCheck,
  title: "Pagos protegidos y flexibles",
  description: "Aceptamos tarjetas de crédito o débito, PayPal, Mercado Pago y pagos en efectivo en tiendas OXXO.",
  tag: "Transacción cifrada"
}];
const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.12
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 16
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.45,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export default function Shipping() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="envíos-y-pagos" data-nav="light" className="bg-background text-foreground py-12 md:py-16 border-y border-border">
      <div className="container mx-auto max-w-[1240px] px-5 sm:px-8 lg:px-14">
        {/* Subtle Section Header */}
        <div className="max-w-2xl mb-10 md:mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent text-accent-foreground text-xs font-semibold tracking-wider uppercase mb-3">
            <span className="w-1.5 h-1.5 rounded-full bg-primary" />
            Garantía Spora
          </div>
          <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl font-medium tracking-tight text-foreground">
            Tu ritual llega seguro y a tiempo
          </h2>
          <p className="mt-2 text-sm sm:text-base text-muted-foreground font-sans">
            Cuidamos cada entrega con empaques protegidos, envíos ágiles a toda la república y métodos de pago confiables.
          </p>
        </div>

        {/* Benefits Grid */}
        <motion.div variants={shouldReduceMotion ? undefined : containerVariants} initial={shouldReduceMotion ? undefined : "hidden"} whileInView={shouldReduceMotion ? undefined : "show"} viewport={{
        once: true,
        amount: 0.2
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {benefits.map((benefit, i) => {
          const IconComponent = benefit.icon;
          return <motion.div key={benefit.title} data-index={i} variants={shouldReduceMotion ? undefined : itemVariants} className="bg-secondary/50 rounded-2xl p-6 sm:p-7 border border-border flex flex-col justify-between">
                <div>
                  <div className="flex items-center justify-between mb-5">
                    <div className="w-12 h-12 rounded-xl bg-card border border-border flex items-center justify-center text-primary shadow-xs">
                      <IconComponent className="w-6 h-6 stroke-[1.5]" />
                    </div>
                    <span className="text-xs font-medium text-muted-foreground px-2.5 py-1 rounded-full bg-card/80 border border-border/60">
                      {benefit.tag}
                    </span>
                  </div>

                  <h3 className="font-serif text-lg sm:text-xl font-medium text-foreground tracking-tight mb-2">
                    {benefit.title}
                  </h3>
                  <p className="text-sm leading-relaxed text-muted-foreground font-sans">
                    {benefit.description}
                  </p>
                </div>

                <div className="mt-6 pt-4 border-t border-border/70 flex items-center gap-2 text-xs font-medium text-foreground/80">
                  <CreditCard className="w-3.5 h-3.5 text-primary" />
                  <span>Compra respaldada de extremo a extremo</span>
                </div>
              </motion.div>;
        })}
        </motion.div>

        {/* Action footnote / quick CTA */}
        <div className="mt-10 pt-8 border-t border-border flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs sm:text-sm text-muted-foreground font-sans">
            ¿Tienes dudas con tu destino o formas de pago especiales? Nuestro equipo te asiste de inmediato.
          </p>
          <Button asChild variant="outline" className="rounded-full px-5 h-10 border-border text-foreground hover:bg-card hover:text-primary transition-colors text-xs font-semibold shrink-0">
            <Link to="/ShopPage">
              Explorar el catálogo
              <ArrowRight className="w-3.5 h-3.5 ml-1.5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}